
import { Component, Prop, Vue } from 'vue-property-decorator';
import DeviceData from '~/components/Data.vue';
import { HeatingAlgoFields } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';

const PERIOD_MAP = new Map([
    [10, 2],
    [18, 3],
    [24, 4],
    [32, 5],
    [40, 6],
    [50, 7],
]);

@Component({
    components: {
        DeviceData,
    },
})
export default class AlgoFields extends Vue {
    @Prop() heatingAlgo!: HeatingAlgoFields;

    get localHeatingAlgoFields() {
        let gain = 0;
        let ti = 0;
        let td = 0;
        // default is 2 apparently
        let period = 2;
        const pidParams = this.heatingAlgo.pid_params;
        if (pidParams) {
            ({ gain, ti, td, period } = pidParams);
        }

        const houseModelParams =
            this.heatingAlgo.station ?? this.heatingAlgo.gefs;

        const fields: FieldObject[] = [
            {
                key: 'Selected algo',
                value: this.heatingAlgo.simple_algo ? 'Hysteresis' : 'PID',
            },
            {
                key: 'Hysteresis threshold',
                value: `${((this.heatingAlgo.simple_params?.high_deadband || 0) + 1) / 10} °C`,
            },
            {
                key: 'PID value',
                value: `gain ${gain} | ti ${ti} | td ${td} | min duration ${PERIOD_MAP.get(period)} minutes`,
            },
            {
                key: 'Thermoregulation RC model',
                value: `tau ${houseModelParams?.tau} | pk ${houseModelParams?.pk}
                | lag_up ${houseModelParams?.lag_up} | lag_down ${houseModelParams?.lag_down}
                | on_overshoot ${houseModelParams?.on_overshoot} | off_overshoot ${houseModelParams?.off_overshoot}`,
            },
            {
                key: 'Last computation',
                value: this.heatingAlgo.time_pid_computed,
                type: 'date',
            },
            {
                key: 'Last computation error',
                value: this.heatingAlgo.last_compute_try,
                type: 'date',
                class: {
                    'error--text':
                        (this.heatingAlgo.last_compute_try || 0) >
                        (this.heatingAlgo.time_pid_computed || 0),
                },
            },
            {
                key: 'Heating prediction',
                value: this.heatingAlgo.in_use,
                type: 'subField',
                subfield: 'in_use',
            },
        ];

        return fields;
    }
}
